import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IAllBusinessPlansResponse } from 'services/businessPlan/types';

import { businessPlanQueryKeys } from '../businessPlan-qk';
import { BusinessPlanApi } from '../businessPlan.api';

export const useDeleteBusinessPlan = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: BusinessPlanApi.deleteBusinessPlan,
    onMutate: (uuid) => {
      queryClient.setQueryData<IAllBusinessPlansResponse>(
        businessPlanQueryKeys.businessPlans(),
        (oldData: IAllBusinessPlansResponse | undefined) => {
          if (!oldData) {
            return oldData;
          }

          return {
            ...oldData,
            content: oldData.content.filter((plan) => plan.uuid !== uuid),
          };
        },
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: businessPlanQueryKeys.businessPlans() });
      queryClient.invalidateQueries({ queryKey: businessPlanQueryKeys.businessPlansLimits() });
    },
  });
};
